<style lang="less" scoped>
    .office-map-backdrop{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        background: rgba(55,55,55,.6);
        text-align: center;
    }
    .office-map{
        position: relative;
        background: white;
        border-radius: 6px;
        min-width: 800px;
        min-height: 400px;
        max-height: 600px;
    }
    .office-map-backdrop .office-map{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 10px;
        z-index: 999;
        text-align: left;
    }
    .canvas-container{
        position: relative;
        display: inline-block;
        width: 800px;
    }
    .img-container{
        position: relative;
        display: inline-block;
        width: 800px;
        img{
            width: 100%;
        }
    }
    .location{
        position: absolute;
        display: inline-block;
        transition: .3s;
        font-size: 24px;
        line-height: 1;
        color: #2d8cf0;
        text-shadow: 0 -1px 3px #000;
    }
    .location-dot{
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #2d8cf0;
    }
    .office-map-label{
        position: absolute;
        display: inline-block;
        padding: 2px 4px;
        color: #444;
        font-size: 16px;
        font-family: FZShuTi, STXingkai, monospace;
    }
    .close-btn{
        display: inline-block;
        font-size: 16px;
        cursor: pointer;
        line-height: 1;
        transition: .3s;
    }
    .close-btn:hover{
        color: #000;
        transform: scale(1.2,1.2);
    }
</style>
<template>
    <div :class="{'office-map-backdrop': config.fixed}" v-show="config.show">
        <div class="office-map">
            <div class="header">
                <span class="close-btn pull-right" @click="hide" v-if="config.fixed">
                    <Icon type="md-close"></Icon>
                </span>
            </div>
            <div class="img-container" v-if="img_url">
                <img :src="img_url">
                <div class="location" :style="location_style" v-show="has_location">
                    <span class="location-bounce"><Icon type="ios-pin"></Icon></span>
                    <span class="location-dot"></span>
                </div>
            </div>
            <div class="canvas-container" v-show="cur_map.id && !img_url">
                <canvas class="canvas"
                    ref="canvas"
                    :width="canvas_width"
                    :height="canvas_height"></canvas>
                <div class="location" :style="location_style" v-show="has_location">
                    <span class="location-bounce"><Icon type="ios-pin"></Icon></span>
                    <span class="location-dot"></span>
                </div>
            </div>
            <Spin size="large" fix v-if="loading"></Spin>
        </div>
    </div>
</template>
<script>
    import Rough from 'roughjs/dist/rough.es5.umd';
    export default {
        props: {
            customer_id: {
                type: Number,
                'default': 0
            },
            config: {
                type: Object,
                'default': {
                    show: true,
                    fixed: false
                }
            }
        },
        data () {
            return {
                loading: false,
                cur_map: {items: [], labels: []},
                location: {office_map_id: 0, pos_x: 0, pos_y: 0},
            }
        },
        computed: {
            canvas_width(){
                return this.cur_map.width ? this.cur_map.width : 800;
            },
            canvas_height(){
                return this.cur_map.height ? this.cur_map.height : 600;
            },
            has_location(){
                return this.location.office_map_id > 0 && this.location.pos_x > 0 && this.location.pos_y > 0;
            },
            location_style(){
                return {
                    top: this.location.pos_y + 'px',
                    left: this.location.pos_x + 'px',
                    transform: 'translate3d(-50%, -100%, 0)',
                }
            },
            img_url() {
                return this.cur_map.img_addr ? `${this.$util.publicOSSUrl(this.cur_map.img_addr)}?x-oss-process=style/map` : '';
            }
        },
        created(){
            this.init();
        },
        mounted(){
            this.initCanvas();
        },
        methods: {
            init(){
                if(this.customer_id){
                    this.getLocation();
                }
            },
            initCanvas(){
                this.ctx = this.$refs.canvas.getContext('2d');
                this.rc = Rough.canvas(this.$refs.canvas);
                this.generator = this.rc.generator;
            },
            show(){
                this.config.show = true;
                this.getLocation();
            },
            hide(){
                this.config.show = false;
            },
            getLocation(){
                this.loading = true;
                Util.ajax.get(Util.api.office_map_location, {
                    params: {
                        customer_id: this.customer_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    if(res.code === 1){
                        let data = res.data;
                        if(data.map){
                            data.map.items = data.map.content ? JSON.parse(data.map.content) : [];
                            data.map.labels = data.map.labels ? JSON.parse(data.map.labels) : [];
                            delete data.map.content;
                            this.cur_map = data.map;
                        }
                        if(data.location){
                            this.location = data.location;
                        }
                        if(data.map && data.location){
                            this.reDraw();
                        }
                    }else{
                        this.$Modal.error({title: '提示', content: res.msg});
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({title: '提示', content: e.message});
                });
            },
            labelStyle(label){
                return {
                    top: label.y + 'px',
                    left: label.x + 'px',
                }
            },
            getPoints(points){
                let arr = [];
                points.forEach((point)=>{
                    arr.push([point.x, point.y]);
                });
                return arr;
            },
            genShape(item){
                let shape;
                let d = item.data;
                switch (item.shape){
                    case 'line':
                        shape = this.generator.line(d.x1, d.y1, d.x2, d.y2, d.options);
                        break;
                    case 'rectangle':
                        shape = this.generator.rectangle(d.x, d.y, d.w, d.h, d.options);
                        break;
                    case 'ellipse':
                        shape = this.generator.ellipse(d.x, d.y, d.w, d.h, d.options);
                        break;
                    case 'circle':
                        shape = this.generator.circle(d.x, d.y, d.d, d.options);
                        break;
                    case 'linearPath':
                        shape = this.generator.linearPath(this.getPoints(d.points), d.options);
                        break;
                    case 'polygon':
                        shape = this.generator.polygon(this.getPoints(d.points), d.options);
                        break;
                    case 'arc':
                        shape = this.generator.arc(d.x, d.y, d.w, d.h, d.start, d.stop, d.closed, d.options);
                        break;
                    case 'curve':
                        shape = this.generator.curve(this.getPoints(d.points), d.options);
                        break;
                    case 'path':
                        shape = this.generator.path(d.val, d.options);
                        break;
                    default:
                        console.error('undefined shape', item);
                        break;
                }
                return shape;
            },
            drawLabel(label){
                const font_size = label.fontSize || 30;
                const font = `${label.fontWeight} ${font_size}px ${label.font}`;
                this.ctx.font = font;
                this.ctx.fillStyle = label.fillStyle;
                this.ctx.textAlign = label.textAlign;
                this.ctx.textBaseline = label.textBaseline;
                label.w = this.ctx.measureText(label.text).width;
                label.h = font_size;
                this.ctx.fillText(label.text, label.x, label.y);
            },
            draw(){
                this.cur_map.items.forEach((item)=>{
                    let shape = this.genShape(item);
                    this.rc.draw(shape);
                });
                this.cur_map.labels.forEach((label)=>{
                    this.drawLabel(label);
                });
            },
            reDraw(){
                this.ctx.clearRect(0,0,this.canvas_width, this.canvas_height);
                this.draw();
            }
        }
    }
</script>
